import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin-bottom: 8px;
`;
